
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-script-generator",
      function () {
        return require("private-next-pages/video-script-generator/index.tsx");
      }
    ]);
  